





























import mixins from 'vue-typed-mixins';
import FunctionalCenterUtils, {
  FunctionalCenter,
} from '@/utils/FunctionalCenterUtils';
export default mixins().extend({
  computed: {
    headers() {
      return [
        { text: this.$tc('model.functionalcenter.code'), value: 'code' },
        {
          text: `${this.$t('model.common.name')} (${this.$t(
            'app.label.locale.en'
          )})`,
          value: 'name_en',
        },
        {
          text: `${this.$t('model.common.name')} (${this.$t(
            'app.label.locale.fr'
          )})`,
          value: 'name_fr',
        },
      ];
    },
  },
  data(): {
    items?: FunctionalCenter[];
  } {
    return {
      items: undefined,
    };
  },
  async mounted() {
    try {
      this.items = await FunctionalCenterUtils.api.list();
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'functional-center-create' });
    },
    async edit(item: FunctionalCenter) {
      await this.$router.push({
        name: 'functional-center-edit',
        params: { functionalCenterId: `${item.id}` },
      });
    },
    async importCSV() {
      // console.log('import');
    },
    async exportCSV() {
      // console.log('export');
    },
    async remove(item: FunctionalCenter) {
      try {
        this.$alert.hide('remove');
        await FunctionalCenterUtils.api.remove(item.id as number);
        if (this.items) {
          const index = this.items.findIndex((val) => val.id === item.id);
          if (index >= 0) {
            this.items.splice(index, 1);
          }
        }
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.delete', {
            values: [this.$languageobj('model.functionalcenter.label')],
          }),
        });
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
